import { Button } from '@krp/ui-kit'

import { OneCQueryState } from '../../../shared/ui/OneCQueryState'
import type { HistoryActions, HistoryVm } from '../model/viewModels'

/** Раздел «История»: журнал правок поставки и журнал попыток проведения — только чтение. */
export function HistorySection({ vm, actions }: { vm: HistoryVm; actions: HistoryActions }) {
  return (
    <div className="onec-screen">
      <section className="onec-section" aria-label="Журнал правок">
        <div className="onec-section__head">
          <strong>Правки</strong>
          <Button variant="ghost" onClick={actions.reload}>
            Перечитать
          </Button>
        </div>
        <p className="onec-muted">Выгрузка журнала в CSV появится, когда transport научится отдавать файлы (запрос интегратору).</p>
        <OneCQueryState query={vm.query} emptyText="Правок нет" onRetry={actions.reload} />
        {vm.entries.length > 0 && (
          <div className="onec-scroll">
            <table className="onec-table">
              <thead>
                <tr>
                  <th>Когда</th>
                  <th>Кто</th>
                  <th>Что</th>
                  <th>Было</th>
                  <th>Стало</th>
                </tr>
              </thead>
              <tbody>
                {vm.entries.map((entry) => (
                  <tr key={entry.id}>
                    <td>{entry.occurredAt}</td>
                    <td>
                      {entry.userName ?? '—'} · {entry.sourceName}
                    </td>
                    <td>
                      {entry.actionName}
                      {entry.lineNumber !== null ? `, строка ${entry.lineNumber}` : ''}
                      {entry.fieldName !== null ? `, ${entry.fieldName}` : ''}
                      {entry.comment !== null && <div className="onec-muted">{entry.comment}</div>}
                    </td>
                    <td>{entry.oldValue ?? '—'}</td>
                    <td>{entry.newValue ?? '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {vm.canLoadMore && (
          <Button variant="secondary" onClick={actions.loadMore}>
            Показать ещё
          </Button>
        )}
      </section>
      <section className="onec-section" aria-label="Журнал проведения">
        <div className="onec-section__head">
          <strong>Попытки проведения</strong>
        </div>
        <OneCQueryState query={vm.logQuery} emptyText="Поставку ещё не проводили" onRetry={actions.reload} />
        {vm.attempts.map((attempt) => (
          <details key={attempt.attemptNumber}>
            <summary>
              Попытка №{attempt.attemptNumber}: выполнено {attempt.succeeded}, ошибок {attempt.failed}, пропущено {attempt.skipped} из{' '}
              {attempt.total}
            </summary>
            <ol className="onec-steps">
              {attempt.steps.map((step, index) => (
                <li key={`${step.stepKind}-${index}`}>
                  <div>
                    {step.stepKindName} — {step.statusName}
                    {step.documentNumber !== null ? ` · №${step.documentNumber}` : ''}
                    {step.resourceErrorText !== null && <p className="onec-problem">{step.resourceErrorText}</p>}
                  </div>
                </li>
              ))}
            </ol>
          </details>
        ))}
      </section>
    </div>
  )
}
